import { render } from "./SubscribeStarSvg.vue?vue&type=template&id=12affe94"
import script from "./SubscribeStarSvg.vue?vue&type=script&lang=js"
export * from "./SubscribeStarSvg.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__